import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const EuroIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" fillRule="evenodd" stroke="none" {...props}>
      {/* eslint-disable max-len */}
      <path d="M9.349 14.896h6.726v-1.806h-7.174c-0.098-0.727-0.098-1.465 0-2.192h7.174v-1.806h-6.726c0.825-2.202 2.545-3.945 4.727-4.788s4.617-0.707 6.692 0.374l1.032-2.003c-2.773-1.446-6.043-1.564-8.911-0.321s-5.033 3.715-5.898 6.738h-4.791v1.806h4.444c-0.076 0.729-0.076 1.464 0 2.192h-4.444v1.806h4.791c0.857 3.028 3.021 5.508 5.892 6.752s6.146 1.121 8.917-0.335l-1.032-2.003c-3.162 1.664-7.032 1.060-9.546-1.491-0.824-0.828-1.463-1.825-1.873-2.922z" />
    </SvgIcon>
  );
};
